import {Fragment} from 'react';

import {TenantInvoiceSettingMasterService as Service} from './TenantInvoiceSettingMasterService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useTranslation} from '../../../shared/language';

export const List = () => {

  const {t} = useTranslation();
  const header = t('system.invoiceConfig');
  const dataKey = 'id';

  const {render: renderDataTable, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'name', header: t('system.configCode'), width: 250, matchMode: 'contains'},
      {field: 'typeInvoiceName', header: t('system.invoiceType'), minWidth: 250, matchMode: 'contains'}
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const {renderToolbar} = useToolbar({
    dataKey,
    create: () => {
      window.location.hash = '/he-thong/cau-hinh-hoa-don/create';
    },
    update: (item: any) => {
      window.location.hash = '/he-thong/cau-hinh-hoa-don/update/' + item.id;
    },
    deleteItem: (id) => {
      return Service.delete(id);
    },
    reloadLazyData,
    selectedItems
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
    </Fragment>
  )
}
